import { createListenerMiddleware } from '@reduxjs/toolkit';
import { deletePayment, isDeletingPayment } from '../ducks/paymentSlice';
import { AppState } from '../types/AppState';
import { unknownGroup } from '../constants/Group';
import { integrationApi } from '../services/integrationApi';
import { Dialogs } from '../constants/Dialogs';
import { closeDialog, openDialog } from '../ducks/dialogSlice';
import { I18nKeys } from '../constants/I18nKeys';
import { i18n } from '../i18n';

export const paymentListener = createListenerMiddleware<AppState>();

paymentListener.startListening({
  actionCreator: deletePayment,
  effect: async (action, { dispatch, getState }) => {
    const state = getState();

    const {
      currentUser: { group: { groupId } = unknownGroup },
    } = state;
    const { clientId, hash, context } = action.payload;
    dispatch(isDeletingPayment(true));
    dispatch(
      openDialog({
        dialog: Dialogs.Loading,
        options: {
          title: i18n.t(I18nKeys.PaymentActionDialogLoadingText, { context }),
        },
      }),
    );

    await dispatch(
      integrationApi.endpoints.deletePayment.initiate({
        clientId,
        groupId,
        hash,
      }),
    );
    dispatch(isDeletingPayment(false));
    dispatch(closeDialog());
  },
});
